import { useMemo, useState } from 'react';
// utils
import { LoadingContext } from './loading-context';

// ----------------------------------------------------------------------

type Props = {
    children: React.ReactNode;
};

export function LoadingProvider({ children }: Props) {
    const [loadingCount, setLoadingCount] = useState(0);

    // SHOW LOADING
    const showLoading = () => {
        setLoadingCount(loadingCount + 1);
    };

    // HIDE LOADING
    const hideLoading = () => {
        setLoadingCount(loadingCount > 0 ? loadingCount - 1 : 0);
    };

    const memoizedValue = useMemo(
        () => ({
            loadingCount,
            //
            showLoading,
            hideLoading
        }),
        // eslint-disable-next-line
        [loadingCount]
    );

    return <LoadingContext.Provider value={memoizedValue}>{children}</LoadingContext.Provider>;
}
